import { FormControl, FormHelperText, MenuItem, Select } from "@mui/material";
import { Box } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";

const initialState = {
    data: [],
    filtered: [],
    country: '',
    food: ''
}

let countries = [];
const foods = [];

const FilteredDataGrid = (props) => {

    const csv = props.csv;
    const { readString } = usePapaParse();
    const [state, setState] = useState(initialState);

    const handleReadString = () => {
        readString(csv, {
            complete: (results, file) => {
                setState(prevState => {
                    const data = results.data;
                    data.map((d, idx) => {
                        d.id = idx
                    });

                    data.forEach(d => {
                        if (countries.indexOf(d['Country of origin of the sample taken']) < 0) {
                            countries.push(d['Country of origin of the sample taken']);
                        }
                        if (foods.indexOf(d['Food commodity']) < 0) {
                            foods.push(d['Food commodity']);
                        }
                    });

                    // countries = countries.sort((a, b) => a > b ? 1 : -1);
                    // foods.sort((a, b) => a > b ? 1 : -1);

                    const country = countries.sort((a, b) => a > b ? 1 : -1)[0];
                    const food = foods.sort((a, b) => a > b ? 1 : -1)[0];
                    const filtered = data.filter(d => d['Country of origin of the sample taken'] === country);

                    return {
                        data,
                        filtered,
                        country,
                        food
                    }
                })
            },
            download: true,
            header: true,
            dynamicTyping: true,
            error: (error, file) => {
                console.log('Error while parsing:', error, file);
            },
        });
    };

    useEffect(() => {
        handleReadString();
    }, []);


    const handleCountrySelectChange = (event) => {
        setState((prevState) => {
            const country = event.target.value
            const filtered = prevState.data.filter(d => d['Country of origin of the sample taken'] === country);
            return {
                data: prevState.data,
                filtered,
                country,
                food: prevState.food
            }
        });
    }
    const handleFoodSelectChange = (event) => {
        setState((prevState) => {
            const food = event.target.value
            const filtered = prevState.data.filter(d => d['Country of origin of the sample taken'] === prevState.country && d['Food commodity'] === food);
            return {
                data: prevState.data,
                filtered,
                country: prevState.country,
                food
            }
        });
    }

    const cols = [
        { field: 'Report name', headerName: 'Pesticide', flex: 1, minWidth: 100 },
        { field: 'Food commodity', headerName: 'Food commodity', flex: 1, minWidth: 100 },
        { field: 'Quantified result', type: 'number', headerName: 'Quantified results', flex: 1, minWidth: 100 },
        { field: 'Above legal limit result', type: 'number', headerName: 'Above legal limit', flex: 1, minWidth: 100 },
        { field: 'Result non compliant for pesticides', type: 'number', headerName: 'Non compliant', flex: 1, minWidth: 100 },
    ]

    return (
        <Box sx={{ height: 400 }}>
            <Box>
                <FormControl sx={{ m: 1, minWidth: 120 }}>
                    <FormHelperText>Select country of origin</FormHelperText>

                    <Select value={state.country} onChange={handleCountrySelectChange}>
                        {
                            countries.map((c, idx) => {
                                return <MenuItem key={idx} value={c}>{c}</MenuItem>
                            })
                        }
                    </Select>
                </FormControl>
            </Box>
            {countries.length > 0 && <DataGrid columns={cols} rows={state.filtered} components={{
                Toolbar: GridToolbar,
            }} />}
        </Box>
    );
}

export default FilteredDataGrid;